<section class="card fraud-map-panel">
  <header class="fraud-panel-heading">
    <h2>مقایسه مسیر دو خودرو</h2>
    <div class="fraud-legend"><span><i class="fraud-dot blue"></i>خودروی اول</span><span><i class="fraud-dot red"></i>خودروی دوم</span></div>
  </header>
  <div class="fraud-route-actions">
    <button class="btn btn-primary" type="button" [disabled]="loading" (click)="loadRequested.emit()">{{ loading ? 'در حال دریافت مسیر...' : 'نمایش مسیر' }}</button>
  </div>
  <p *ngIf="error || mapError" class="fraud-message error">{{ error || mapError }}</p>
  <div class="fraud-map-wrap">
    <div #mapTarget class="fraud-map" dir="ltr"></div>
    <div *ngIf="loading" class="loader show"><div class="spinner"></div><span>در حال دریافت مسیرها...</span></div>
    <div *ngIf="routeCounts === null && !loading" class="fraud-map-placeholder">
      <i class="fa fa-map-o" aria-hidden="true"></i><span>برای مقایسه مسیرها، روی «نمایش مسیر» کلیک کنید.</span>
    </div>
    <div *ngIf="routeCounts && !routeCounts[0] && !routeCounts[1] && !loading" class="fraud-map-placeholder">
      <i class="fa fa-map-marker" aria-hidden="true"></i><span>برای این روز، موقعیت معتبری برای نمایش یافت نشد.</span>
    </div>
  </div>
  <p class="fraud-map-note muted">
    <ng-container *ngIf="routeCounts">نقاط معتبر: خودروی اول {{ routeCounts[0] | number | faNum }}، خودروی دوم {{ routeCounts[1] | number | faNum }}. </ng-container>
    خطوط در وقفه‌های بیش از {{ 180 | faNum }} ثانیه قطع می‌شوند.
  </p>
</section>
